import React, { Component } from "react";
import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/adrAttachmentPreview.css";
import adrActions from "../../_actions/adrActions";
import { contextTypes } from "../../_constants/fileUploadContextTypes";

class AdrLocAttachmentsV3 extends Component {
  handleClick_edit = (e) => {
    e.preventDefault();
    this.props.toggleModal_fileUpload();
  };

  handleClick_download_all = async (e) => {
    e.preventDefault();
    const { dispatch, locationWorkPerformed: locWp, jobStamp } = this.props;
    const attachments = locWp ? locWp.attachments || [] : [];
    const files = attachments
      .filter((a) => !a.isDeleted)
      .map((a) => ({
        filePath: a.filePath,
        fileNameAlias: a.originalFileName,
      }));
    await dispatch(adrActions.requestAttachments(jobStamp.fullEA, files));
  };

  handleClick_toggleDelete = (fileRowIndex) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { dispatch, tabId, wpTabId, locationWorkPerformed: locWp } = this.props;
    const params = {
      tabId,
      wpTabId,
      clientId: locWp.clientId,
      locWpaIndex: fileRowIndex,
    };
    dispatch(adrActions.toggleDeleteAttachment(params, contextTypes.LOCWP));
  };

  // getFileName = (fileRowIndex) => this.props.attachments[fileRowIndex].originalFileName;

  renderThumbnail = (attachment, fileRowIndex) => {
    const ext = attachment.originalFileName
      ? attachment.originalFileName.split(".").pop().toLowerCase()
      : "";
    let icon = "file";
    if (["doc", "docx"].includes(ext)) icon = "file-word";
    else if (["xls", "xlsx"].includes(ext)) icon = "file-excel";
    else if (ext === "pdf") icon = "file-pdf";
    else if (ext === "zip") icon = "file-archive";

    const deleteButton = (
      <button
        name="toggleDeleteAttachment"
        className={`btn btn-sm thumbnail-delete-button ${
          attachment.isDeleted ? "btn-outline-success" : "btn-outline-danger"
        }`}
        onClick={this.handleClick_toggleDelete(fileRowIndex)}
      >
        {attachment.isDeleted ? (
          <FontAwesomeIcon icon="trash-restore" className="fa-fw" />
        ) : (
          <FontAwesomeIcon icon="trash-alt" className="fa-fw" />
        )}
      </button>
    );

    return (
      <div
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.props.dispatch(adrActions.openFile(attachment.filePath)); }}
        className="pointer-cursor"
      >
        {deleteButton}
        {attachment.imageThumbnailFilePath ? (
          <img
            src={attachment.thumbnailBase64}
            alt="(Cannot display thumbnail)"
            className="thumbnail"
          />
        ) : (
          <FontAwesomeIcon icon={["far", icon]} className="fa-fw fa-3x" />
        )}
      </div>
    );
  };

  render() {
    const {
      idSuffix,
      locationWorkPerformed: locWp,
      showLaBlock,
      toggleLaBlock,
    } = this.props;

    const attachments = locWp ? locWp.attachments || [] : [];

    return (
      <div className="locwp-row-att">
        <div className="card mb-2 w-100 bg-lightgray">
          <div className="card-body p-2">
            <div
              id={`laToggler_${idSuffix}`}
              className="mb-0 loc-wp-subsection-toggler"
              onClick={toggleLaBlock}
            >
              <FontAwesomeIcon
                icon={showLaBlock ? "caret-down" : "caret-right"}
                className="fa-fw mr-1"
              />
              <b>
                <i>Preview Attached Photos</i>
              </b>
              <span className="badge badge-pill badge-danger my-auto ml-2">
                {attachments && attachments.length}
              </span>
            </div>
            <Collapse isOpen={showLaBlock}>
              <div className="d-flex flex-row flex-wrap">
                {attachments &&
                  attachments.map((la, index) => (
                    <div
                      key={`locAttachPreviewKey_${
                        locWp.isSublocation
                          ? la.sublocationAttachmentId
                          : la.locationWorkPerformedAttachmentId
                      }_${index}`}
                      className="card m-1 align-self-start"
                    >
                      <div className="card-body p-2 thumbnail-content">
                        {this.renderThumbnail(la, index)}
                      </div>
                    </div>
                  ))}
                <div className="card m-1">
                  <div className="card-body p-2 btn-edit-attachment-container">
                    <div className="d-flex flex-column flex-fill">
                      <div className="mb-1">
                        <button
                          type="button"
                          name="editAttachments"
                          id={`editLa_${idSuffix}`}
                          className="btn btn-outline-secondary btn-edit-attachment mb-1"
                          onClick={this.handleClick_edit}
                        >
                          <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
                          Edit...
                        </button>
                      </div>
                      <div>
                        <button
                          type="button"
                          name="requestAttachments"
                          id={`downloadAllLas_${idSuffix}`}
                          className="btn btn-outline-secondary btn-edit-attachment mb-1"
                          onClick={this.handleClick_download_all}
                        >
                          <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
                          Download All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appSettings: state.appSettings,
});

export default connect(mapStateToProps)(AdrLocAttachmentsV3);
